export const ENVIRONMENTS = [
	{ val: 0, text: "Test" },
	{ val: 1, text: "Development" },
	{ val: 2, text: "PreProduction" },
	{ val: 3, text: "Prod" },
];

export const DATE_FORMAT = "MM/DD/YYYY HH:mm:ss";

export const DEFAULT_PAGING_SIZE = 200;

export const PAGING_SIZES = [25, 50, 100, 200, 300, 400];

export const REDUCER_ACTIONS = {
	SET_SUBSCRIPTION: "SET_SUBSCRIPTION",
	SET_PRODUCTID: "SET_PRODUCTID",
	TOKEN_CACHE_NOT_FOUND: "TOKEN_CACHE_NOT_FOUND",
};

export const DEFAULT_TWILIO_SUBSCRIPTION_CONFIG = {
	Environment: 0,
	AccountSid: "",
	TwilioApiKeySid: "",
	TwilioApiKeySecret: "",
	PIIRemovalPropertyNamesCsv: "",
	IsLogLevelOverrideEnabled: false,
	TwilioLoggingConfiguration: {
		LogVerbose: false,
		LogInfo: true,
		LogWarn: true,
		LogError: true,
		LogCritical: true,
		LogBusinessEvent: true,
	},
};

export const DEFAULT_AMAZON_CONNECT_SUBSCRIPTION_CONFIG = {
	Environment: 0,
	ConnectInstanceId: "",
	ConnectLoggingConfiguration: {
		LogVerbose: false,
		LogInfo: true,
		LogWarn: true,
		LogError: true,
		LogCritical: true,
		LogBusinessEvent: true,
	},
	IsLogLevelOverrideEnabled: false,
};

export const CLE_TYPES: { [key: number]: string } = {
	0: "None",
	1: "Twilio",
	2: "AmazonConnect",
};

//This is used for mapping the various event sources found in cle to a proper title string for the card component.
export const EVENT_CARD_TITLES = {
	taskRouter: "TASK ROUTER",
	runtimeDebugger: "DEBUGGER",
	cloudFunction: "CLOUD FUNCTION",
	browserFunction: "BROWSER FUNCTION",
	platformStatus: "PLATFORM",
	callEvent: "CALL EVENT",
	flowExecutionStep: "FLOW EXECUTION",
	callList: "CALL",
	channelList: "CHANNEL",
};

//This is used for mapping the various cle types found in cle to a proper title string for the card component.
export const FILTER_TITLES = {
	taskRouter: "Task Router Events",
	runtimeDebugger: "Debugger Events",
	cloudFunction: "Cloud Function Events",
	browserFunction: "Browser Function Events",
	function: "Custom Log Events",
	platformStatus: "Platform Events",
	callEvent: "Call Events",
	flowExecutionStep: "Flow Execution Steps",
};

export const EVENT_ID_TITLES = {
	10000: "Always",
	20000: "Critical",
	30000: "Error",
	40000: "Warning",
	50000: "Info",
	50012: "Business",
	60000: "Verbose",
};

export const DISPLAY_LOG_LEVELS = {
	Always: "logAlways",
	Critical: "critical",
	Error: "error",
	Warning: "warning",
	Informational: "informational",
	Verbose: "verbose",
};

export const LOG_LEVELS = {
	logAlways: 0,
	critical: 1,
	error: 2,
	warning: 3,
	informational: 4,
	verbose: 5,
};

export enum ServiceMessagingService {
	/// PDP service (1)
	pdp = "PDP",
	/// CLE service (2)
	cle = "CLE",
	/// POW service (3)
	pow = "POW",
	/// PDP Web Jobs service (4)
	pdpWebJobs = "PDP Web Jobs",
	/// CLE Web Jobs service (5)
	cleWebJobs = "CLE Web Jobs",
}

// Defines the Currency for the BillingPlan
export const CURRENCY = [
	{ val: "0", text: "USD" },
	{ val: "1", text: "CAD" },
];

// Defines the Period for a BillingPlan
export const PERIOD = [{ val: "0", text: "Monthly" }];

export const MIN_TABLE_HEIGHT = 500;

export const MAX_TABLE_HEIGHT = 960;

export const TWILIO_PRODUCT_ID = "ab24416a-8abe-4ac6-9462-c37b8d89c783";
